import Api from "./Api";
import apiPath from "@/constants/api.js";

export default {
  checkMta(options) {
    const response = Api().post(apiPath.check_mta, options);
    return response;
  }
};
